module.exports = __webpack_public_path__ + "img/Tips.551e3f06.png";